module.exports = __webpack_public_path__ + "7e7a8502f2b7fa21e5179bca95cad1bc.pdf";